"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepgramVoiceIdEnum = void 0;
exports.DeepgramVoiceIdEnum = {
    Asteria: "asteria",
    Luna: "luna",
    Stella: "stella",
    Athena: "athena",
    Hera: "hera",
    Orion: "orion",
    Arcas: "arcas",
    Perseus: "perseus",
    Angus: "angus",
    Orpheus: "orpheus",
    Helios: "helios",
    Zeus: "zeus",
};
